import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogOverlay,
  Box,
  Button,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useRef } from "react";

import { ReactComponent as ConfirmIcon } from "src/assets/icon/confirm-icon.svg";
import { useDeleteLocationMutation } from "src/hook/location/location";
import { RowType } from "src/template/network/location/location.type";

interface Props {
  idLocation: string;
  isOpen: boolean;
  onClose: () => void;
  setOpenSuccess: () => void;
  refetch: () => void;
  setListLocation: any;
  setPageIndex: any;
  listLocation: RowType[];
}

const ConfirmDeleteLocationComponent = (props: Props) => {
  const {
    isOpen,
    onClose,
    idLocation,
    setOpenSuccess,
    refetch,
    listLocation,
    setPageIndex,
  } = props;
  const [deleteLocation, { isLoading }] = useDeleteLocationMutation();

  const cancelRef = useRef();
  const toast = useToast();
  const submitDelete = () => {
    deleteLocation(idLocation)
      .unwrap()
      .then(() => {
        if (listLocation.length === 1) {
          setPageIndex((pre) => ({ ...pre, page: pre?.page - 1 }));
        } else {
          refetch();
        }
        onClose();
        setOpenSuccess();
      })
      .catch((err) => {
        toast({
          status: "error",
          title: "Delete Location",
          description: err?.data?.message,
          position: "top",
          isClosable: true,
          duration: 2000,
        });
      });
  };

  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef as any}
        onClose={onClose}
      >
        <AlertDialogOverlay bg={"#052A6E"} opacity={"0.7 !important"} />
        <AlertDialogContent
          minW={"42%"}
          color={"#171E38"}
          bg={"#F2F5FC"}
          top={"50%"}
          // left={"50%"}
          transform={"translateY(-50%) !important"}
          m={0}
        >
          <AlertDialogCloseButton
            _focusVisible={{
              outline: "none",
              border: "none",
            }}
            size={"lg"}
          />
          <AlertDialogBody p={"40px"} textAlign={"center"}>
            <Box display={"flex"} justifyContent={"center"} mb={"10px"}>
              <ConfirmIcon stroke={"#E54E43"} />
            </Box>
            <Text
              fontSize={"40px"}
              fontFamily={"Avenir Black"}
              lineHeight={"55px"}
            >
              Confirm deletion
            </Text>
            <Text fontSize={"18px"} fontFamily={"Avenir Medium"} mb={"24px"}>
              Are you sure you want to delete this location?
            </Text>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              fontFamily={"Avenir Black"}
            >
              <Button
                variant={"solid"}
                bg={"#E74D3D"}
                w={"65%"}
                height={"54px"}
                borderRadius={"37px"}
                mr={"16px"}
                color={"#FFFFFF"}
                fontSize={"20px"}
                isLoading={isLoading}
                _hover={{
                  bg: "#E74D3D",
                  opacity: 0.8,
                }}
                onClick={submitDelete}
              >
                Delete
              </Button>
            </Box>
          </AlertDialogBody>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default ConfirmDeleteLocationComponent;
